import ReactLoadable from 'react-loadable'
import LoadingSpinner from '../components/partials/LoadingSpinner'

/**
 * HOC for wrapping components in a react-loadable function
 * @param {string} path - relative from /src directory
 * @param {{}} options
 * @constructor
 */
const Loadable = (path, loading = false, options = {}) => {
  let loader = () => null
  if (loading) {
    loader = LoadingSpinner
  }
  return ReactLoadable({
    loader: () => import(`../${path}`),
    loading: loader,
    ...options,
  })
}

export default Loadable
